import { GenericBackendResponse } from '../genericBackendResponse';

/**
 * El `message` con el que comparsa rechaza el mini-KYC si el KYC no está aprobado
 * (`KycErrorCode.KYC_NOT_APPROVED`, comparsa#799, PR #816). Llega con HTTP 200 y `success: false`.
 */
export const KYC_NOT_APPROVED = 'KYC_NOT_APPROVED';

/** Desde qué flujo de aportación se pide la cuenta. Lo usan los documentos de Caser. */
export type KycBankOperationType = 'aportacion_periodica' | 'aportacion_extraordinaria';

export interface StartBankDataKycInput {
	operationType: KycBankOperationType;
	/**
	 * A dónde vuelve el usuario al terminar. Debe ser un frontend propio:
	 * comparsa rechaza cualquier otro para no ser un redirector abierto.
	 */
	returnUrl: string;
	/** Plan al que va a aportar, por su identificador de Arca. */
	arcaPlanId: string;
}

/**
 * Arranca el mini-KYC de datos bancarios: el usuario da su cuenta y firma el
 * mandato SEPA, nada más.
 *
 * A diferencia de `startKyc`, NO estampa el arranque ni emite la señal de
 * pipeline B2C: esta gente terminó su KYC hace meses y un arranque nuevo
 * contaminaría el embudo.
 */
const startBankDataKyc = async (
	token: string,
	input: StartBankDataKycInput
): Promise<GenericBackendResponse<{ url: string }>> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/kyc/start/bank-data`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(input)
	});

	if (!response.ok) {
		throw new Error(`KYC bank-data start failed: ${response.status}`);
	}

	return response.json();
};

export default startBankDataKyc;
